import { createApiFactory } from '@backstage/core-plugin-api';
import type { ApiEntity } from '@backstage/catalog-model';
import { apiDocsConfigRef, defaultDefinitionWidgets } from '@backstage/plugin-api-docs';
import { protobufWidget } from './components/ProtoDefinition';

export const apis = [
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => ({
      getApiDefinitionWidget: (entity: ApiEntity) =>
        [...defaultDefinitionWidgets(), protobufWidget].find(widget => widget.type === entity.spec.type),
    }),
  }),
];
